// @flow
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import isWindow from '../isWindow';
import isWindowProp from '../isWindowProp';
import getClassifiedsSite from 'utils/getClassifiedsSite';

const path = () =>
  isWindow() && isWindowProp('location')
    ? global.window.location.origin
    : process.env.BASE_URL;

const getUrl = url => {
  const pathname = path();
  return `${pathname}${url}`;
};

class SEO extends PureComponent<*, *> {
  static propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    robots: PropTypes.string.isRequired,
    blurb: PropTypes.string,
    pagination: PropTypes.object,
    schema: PropTypes.object
  };

  getMetaTags = props => {
    const metaTags = [
      { itemprop: 'name', content: props.title },
      { itemprop: 'description', content: props.description },
      { name: 'robots', content: props.robots },
      { name: 'description', content: props.description },
      { name: 'dcterms.publisher', content: 'Haymarket Media Ltd.' },
      { name: 'geo.placename', content: 'London, UK' },
      { name: 'dc.language', content: 'en' },
      { name: 'geo.country', content: 'gb' },
      { name: 'og:url', content: getUrl(props.url) },
      { name: 'og:type', content: 'website' },
      { name: 'og:title', content: props.title },
      { name: 'og:image', content: props.image },
      { name: 'og:description', content: props.description },
      { name: 'og:site_name', content: 'What Car?' },
      { name: 'twitter:card', content: 'summary' },
      { name: 'twitter:site', content: '@WhatCar' },
      { name: 'twitter:title', content: props.title },
      { name: 'twitter:description', content: props.description },
      { name: 'twitter:creator', content: '@WhatCar' },
      { name: 'twitter:image', content: props.image }
    ];

    return metaTags;
  };

  buildLinks = props => {
    let current = '';
    let previous = '';
    let next = '';

    if (props.pagination) {
      const pages = Math.ceil(
        props.pagination.total / props.pagination.pageSize
      );
      current =
        props.pagination.page > 1 ? `?page=${props.pagination.page}` : '';
      next =
        props.pagination.page && props.pagination.page < pages
          ? `?page=${props.pagination.page + 1}`
          : '';
      previous =
        props.pagination.page > 2 ? `?page=${props.pagination.page - 1}` : '';
    }

    const links = [{ rel: 'canonical', href: getUrl(props.url) + current }];

    if ((props.pagination && props.pagination.page === 2) || previous) {
      links.push({ rel: 'prev', href: getUrl(props.url) + previous });
    }

    if (next) {
      links.push({ rel: 'next', href: getUrl(props.url) + next });
    }

    return links;
  };

  render(): Element<*> {
    return getClassifiedsSite() === 'autocar' ? (
      <Helmet
        title={this.props.title}
        link={this.buildLinks(this.props)}
        meta={this.getMetaTags(this.props)}
      />
    ) : (
      <Helmet
        title={this.props.title}
        link={this.buildLinks(this.props)}
        meta={this.getMetaTags(this.props)}
        script={[
          {
            type: 'text/javascript',
            innerHTML: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-5NQHD3');`
          },
          this.props.schema ? this.props.schema : {}
        ]}
      />
    );
  }
}

export default SEO;



// WEBPACK FOOTER //
// ./src/Common/Seo/index.js